import { Config } from '@shared/config';
import { Component, Input, OnInit } from '@angular/core';
import { Category } from '@shared/interfaces/project/category.interface';
import {Tag} from "@shared/interfaces/project/tag.interface";
import {AbstractTag} from "@shared/interfaces/abstract-tag.interfase";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  @Input() categories: AbstractTag[];
  @Input() elementType: string = 'other';

  ukrainianCategories = [];
  constructor() {}

  ngOnInit() {
    this.ukrainianCategories = Config.UKRAINE_CATEGORY.split(',');
  }
  classes(element) {
    return [
      'tags__item',
      element.themed ? 'themed' : '',
      element.id == Config.ECOHEROES_CATEGORY ? 'ecoheroes' : '',
      element.id == 30 ? 'helpukraine' : '',
      element.id == Config.WCD ? 'wcd' : '',
      element.id == Config.BACKBASE_CATEGORY ? 'backbase' : '',
    ];
  }
}
